import classnames from 'classnames';
import styles from './CarriedSlotHotkeyLabel.module.scss';

interface CarriedSlotHotkeyLabelProps {
    readonly slotIndex: number;
    /** The label of the action-bar key linked to the slot (already formatted, e.g. `Space`); empty when none is. */
    readonly keyLabel: string;
    /** The slot is waiting for an action slot to be picked. */
    readonly isLinking: boolean;
    /** Starts picking an action slot for the slot, or cancels it. */
    readonly onClick: () => void;
}

/**
 * The plate under a carried slot on the Inventory tab: the action-bar key
 * linked to it, and the button that links it to another. Shows "?" while
 * it waits for an action slot.
 */
export function CarriedSlotHotkeyLabel({ slotIndex, keyLabel, isLinking, onClick }: CarriedSlotHotkeyLabelProps): JSX.Element {
    const text = isLinking ? '?' : keyLabel;
    return (
        // A plain button: no project component looks like a key plate.
        <button
            type='button'
            className={classnames(styles.carriedSlotHotkeyLabel, keyLabel === '' && styles.unlinked, isLinking && styles.active)}
            onClick={onClick}
            aria-pressed={isLinking}
            aria-label={keyLabel === ''
                ? `Link carried slot ${slotIndex + 1} to an action key`
                : `Carried slot ${slotIndex + 1} is on key ${keyLabel}; change it`}
        >
            {text === '' ? 'Link' : text}
        </button>
    );
}
